module.exports = __webpack_public_path__ + "img/menuIcon7.47c20d93.png";